import React, { FC, useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import Preview from './editor/Preview'
import Editor from './Tabs/Editor/Editor'
import Preferences from './editor/Preferences'
import CompanySettings from './company-management/CompanySettings'

import Loading from '../../Components/loading/Loading'

import './styles.scss'

import Subscribe from './subscribe/Subscribe'
import Share from './editor/Share'
import { Plann3rStore } from '../../store/types'
import { useDispatch, useSelector } from 'react-redux'
import { PagesManagementStore,
  PagesManagementTab } from '../../store/pages-management/types'
import { saveCompanies,
  setActiveTab } from '../../store/pages-management/actions'

import Availabilities from './editor/Availabilities'
import { APP_URL } from '../../constants'

const Detail: FC = () => {
  const [copied, setcopied] = useState(false)
  const [showPopup, setshowPopup] = useState(false)

  const strings = useSelector(
    (state: Plann3rStore) => state.languages.strings.pages.detail,
  )

  const dispatch = useDispatch()

  const {
    isFetching,
    companies,
    saving,
    active_company,
    active_page,
    active_tab,
  } = useSelector(
    (state: Plann3rStore): PagesManagementStore => state.pagesManagement,
  )

  const company = companies.find((company) => company.id === active_company)
  const page =
    active_company && active_page && companies
      ? companies
        .find((company) => company.id === active_company)
        ?.pages.find((page) => page.id === active_page)
      : null

  let link
  if (page && company) {
    link = APP_URL + '/page/' + company.name + '/' + page.name
    link = link.replace(/ /g, '_')
  }

  const not_saved =
    (company ? company.not_saved : false) || (page ? page.not_saved : false)

  const closeModal = () => {
    setshowPopup(false)
  }

  const finishedSubscription = () => {
    closeModal()
    window.location.reload()
  }

  if (isFetching) {
    return (
      <div>
        <Loading />
        <p className="has-text-centered mt-2">{strings.loading_text}</p>
      </div>
    )
  }

  if (companies.length < 1) {
    return (
      <div className="has-text-centered mt-2">
        <p>{strings.first_page}</p>
      </div>
    )
  }

  if (active_tab && page && company) {
    return (
      <div id="details" className="styles details">
        <div>
          <div className="title_top">
            <h2>{page.name}</h2>
            {not_saved && (
              <div className="save_box has-blue-background is-white">
                <div className="align_box">
                  {saving ? (
                    <span>{strings.saving_changes}</span>
                  ) : (
                    <>
                      <span>{strings.unsaved_changes}</span>
                      <button
                        className="button is-secondary"
                        onClick={() => {
                          dispatch(saveCompanies(companies))
                        }}
                      >
                        {strings.save_changes}
                      </button>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
          <div className="details_top">
            <div>
              <ul className="tab_nav green">
                <li
                  className={
                    active_tab === PagesManagementTab.EDITOR
                      ? 'selected second-step'
                      : 'second-step'
                  }
                  onClick={() =>
                    dispatch(setActiveTab(PagesManagementTab.EDITOR))
                  }
                  role="presentation"
                >
                  {strings.edit}
                </li>
                <li
                  className={
                    active_tab === PagesManagementTab.PREFERENCES
                      ? 'selected third-step'
                      : 'third-step'
                  }
                  onClick={() =>
                    dispatch(setActiveTab(PagesManagementTab.PREFERENCES))
                  }
                  role="presentation"
                >
                  {strings.preferences}
                </li>
                {company.admin && (
                  <li
                    className={
                      active_tab === PagesManagementTab.AVAILABILITIES
                        ? 'selected'
                        : ''
                    }
                    onClick={() =>
                      dispatch(setActiveTab(PagesManagementTab.AVAILABILITIES))
                    }
                    role="presentation"
                  >
                    {strings.availabilities}
                  </li>
                )}
                <li
                  className={
                    active_tab === PagesManagementTab.SHARE ? 'selected' : ''
                  }
                  onClick={() =>
                    dispatch(setActiveTab(PagesManagementTab.SHARE))
                  }
                  role="presentation"
                >
                  Share
                </li>
                {link && !not_saved && (
                  <div className="share">
                    <a
                      href={link}
                      target="_blank"
                      className="alink"
                      rel="noopener noreferrer"
                    >
                      {link}
                    </a>

                    <CopyToClipboard text={link} onCopy={() => setcopied(true)}>
                      <button
                        className={
                          copied
                            ? 'button is-primary'
                            : 'button is-primary is-outlined'
                        }
                      >
                        {copied ? strings.copied : strings.copy_clipboard}
                      </button>
                    </CopyToClipboard>
                  </div>
                )}
              </ul>
            </div>
          </div>
        </div>
        <div className="columns">
          <div
            className={active_tab === 'editor' ? 'column is-5' : 'column is-12'}
          >
            {active_tab === PagesManagementTab.EDITOR && <Editor />}
            {active_tab === PagesManagementTab.PREFERENCES && <Preferences />}
            {active_tab === PagesManagementTab.AVAILABILITIES && (
              <Availabilities />
            )}
            {active_tab === PagesManagementTab.SHARE && <Share />}
          </div>
          {active_tab === PagesManagementTab.EDITOR && (
            <div className="column is-7">
              <Preview />
            </div>
          )}
        </div>
        <div>
          {not_saved && (
            <div className="save_box has-blue-background is-white">
              <div className="align_box">
                {!saving && <span>{strings.unsaved_changes}</span>}
                <button
                  className="button is-secondary"
                  onClick={() => {
                    dispatch(saveCompanies(companies))
                  }}
                >
                  {saving ? strings.saving_changes : strings.save_changes}
                </button>
              </div>
            </div>
          )}
        </div>
        <div className={'modal' + (showPopup ? ' is-active' : '')}>
          <div className="modal-background" onClick={closeModal} role="presentation" />
          <div className="modal-content">
            <Subscribe afterSubmit={finishedSubscription} />
          </div>
          <button className="modal-close" onClick={closeModal} />
        </div>
      </div>
    )
  } else {
    return (
      <div id="details" className="detail">
        <CompanySettings />
      </div>
    )
  }
}

export default Detail
